import React, {Component} from 'react';
import Axios from 'axios';
import Switch from 'react-switch';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import withRouter from '../Functions/WithRouter';
import {convertDateToString} from '../Functions/ConvertDateToString';

const deleteIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/delete-icon-dark.png';
const deniedIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/denied-icon.png";
const questionMarkBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/question-mark-blue.png';
const closeIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/close-icon.png';

class EditCertificate extends Component {
    constructor(props) {
      super(props)

      this.state = {
        certificateOptions: [],
        addCertificateMethodOptions: ['','Yes, select from options','No, create a new certificate'],
        certificateDegreeTypeOptions: [],
        estimatedHoursOptions: [],
        industryOptions: [],
        functionOptions: []
      }

      this.addItem = this.addItem.bind(this)
      this.renderTags = this.renderTags.bind(this)
      this.removeTag = this.removeTag.bind(this)
      this.switchPreferences = this.switchPreferences.bind(this)
      this.deleteItem = this.deleteItem.bind(this)
      this.saveChanges = this.saveChanges.bind(this)
      this.generateCertificateId = this.generateCertificateId.bind(this)
      this.unloadCertificate = this.unloadCertificate.bind(this)

    }

    componentDidMount() {
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";

      const profileEmail = this.props.profileEmail
      const selectedCertificate = this.props.selectedCertificate

      const emailId = localStorage.getItem('email');
      // const username = localStorage.getItem('username');
      // const cuFirstName = localStorage.getItem('firstName');
      // const cuLastName = localStorage.getItem('lastName');
      // const pictureURL = localStorage.getItem('pictureURL');
      // const orgFocus = localStorage.getItem('orgFocus');
      // const orgName = localStorage.getItem('orgName');

      let delegateAdminEmail = undefined
      if (profileEmail && profileEmail !== emailId) {
        delegateAdminEmail = emailId
      }

      const activeOrg = localStorage.getItem('activeOrg');

      this.setState({ profileEmail, emailId, delegateAdminEmail })

      if (selectedCertificate) {
        this.unloadCertificate(selectedCertificate)
      }

      Axios.get('/api/org', { params: { orgCode: activeOrg } })
      .then((response) => {
        console.log('Org info query attempted cc', response.data);

          if (response.data.success) {
            console.log('org info query worked')

            let certificateOptions = []
            if (response.data.orgInfo.certificateOptions) {
              certificateOptions = [{ name: '' }].concat(response.data.orgInfo.certificateOptions)
            }

            this.setState({ certificateOptions })

            Axios.get('/api/workoptions')
            .then((response) => {
              console.log('Work options query tried', response.data);

              if (response.data.success) {
                console.log('Work options query succeeded')

                let functionOptions = [{value: 'I am not sure'}]
                for (let i = 1; i <= response.data.workOptions[0].functionOptions.length; i++) {
                  if (i > 1) {
                    functionOptions.push({ value: response.data.workOptions[0].functionOptions[i - 1]})
                  }
                }

                let industryOptions = [{value: 'I am not sure'}]
                for (let i = 1; i <= response.data.workOptions[0].industryOptions.length; i++) {
                  if (i > 1) {
                    industryOptions.push({ value: response.data.workOptions[0].industryOptions[i - 1]})
                  }
                }

                const estimatedHoursOptions = response.data.workOptions[0].durationOptions
                const certificateDegreeTypeOptions = [''].concat(response.data.workOptions[0].certificateDegreeTypeOptions)

                this.setState({ functionOptions, industryOptions, estimatedHoursOptions, certificateDegreeTypeOptions })

              } else {
                console.log('no jobFamilies data found', response.data.message)

                const functionOptions = [{value: 'Undecided'}]
                const industryOptions = [{value: 'Undecided'}]

                this.setState({ functionOptions, industryOptions })

              }
            }).catch((error) => {
                console.log('query for work options did not work', error);
            })

            Axios.get('/api/pathways', { params: { orgCode: activeOrg }})
            .then((response) => {
              console.log('Pathways query attempted no 1', response.data);

              if (response.data.success) {
                console.log('pathway query worked no 1')

                if (response.data.pathways.length !== 0) {

                  let newPathwayOptions = []
                  if (response.data.pathways && response.data.pathways.length > 0) {
                    newPathwayOptions = [{ title: '' }].concat(response.data.pathways)
                  }

                  this.setState({ newPathwayOptions });
                }

              } else {
                console.log('pathway query did not work', response.data.message)
              }

            }).catch((error) => {
                console.log('Pathway query did not work for some reason', error);
            });

            Axios.get('/api/programs', { params: { orgCode: activeOrg }})
            .then((response) => {
              console.log('Programs query attempted no 1', response.data);

              if (response.data.success) {
                console.log('program query worked no 1')

                if (response.data.programs.length !== 0) {

                  let programOptions = []
                  if (response.data.programs && response.data.programs.length > 0) {
                    programOptions = [{ title: '' }].concat(response.data.programs)
                  }

                  this.setState({ programOptions });
                }

              } else {
                console.log('program query did not work', response.data.message)
              }

            }).catch((error) => {
                console.log('Program query did not work for some reason', error);
            });

          } else {
            console.log('org info query did not work', response.data.message)
          }

      }).catch((error) => {
          console.log('Org info query did not work for some reason', error);
      });
    }

    componentDidUpdate(prevProps) {
      console.log('componentDidUpdate called in commonEditCertificate', this.props.activeOrg, prevProps)

      if (this.props.activeOrg !== prevProps.activeOrg) {
        this.retrieveData()
      }
    }

    retrieveData() {
      console.log('retrieveData called in commonEditCertificate', this.props)

    }

    formChangeHandler = (event) => {
      console.log('formChangeHandler called', event.target.name, event.target.value)

      if (event.target.name === 'certificateOption') {
        let selectedCertificateOption = null
        for (let i = 1; i <= this.state.certificateOptions.length; i++) {
          if (this.state.certificateOptions[i - 1].name === event.target.value) {
            selectedCertificateOption = this.state.certificateOptions[i - 1]
          }
        }
        console.log('is name correct 2? ', selectedCertificateOption)
        if (selectedCertificateOption) {

          this.unloadCertificate(selectedCertificateOption)

        }
      } else if (event.target.type === 'date') {
        const formattedDate = new Date(event.target.value)
        if (formattedDate) {
          formattedDate.setHours(formattedDate.getHours() + 12);
          this.setState({ [event.target.name]: formattedDate })
        }
      } else {
        this.setState({ [event.target.name]: event.target.value })
      }
    }

    unloadCertificate(selectedCertificateOption) {
      console.log('unloadCertificate called', selectedCertificateOption)

      const certificateId = selectedCertificateOption.certificateId
      const courseId = selectedCertificateOption._id
      const name = selectedCertificateOption.name
      const imageURL = selectedCertificateOption.imageURL
      const category = selectedCertificateOption.category
      const programURL = selectedCertificateOption.programURL

      let schoolURL = selectedCertificateOption.schoolURL
      let schoolName = selectedCertificateOption.schoolName
      if (selectedCertificateOption.issuerName && selectedCertificateOption.issuerWebsite) {
        let schoolURL = selectedCertificateOption.issuerWebsite
        let schoolName = selectedCertificateOption.issuerName
      }

      const issuerWebsite = selectedCertificateOption.issuerWebsite
      const issuerName = selectedCertificateOption.issuerName

      const degreeType = selectedCertificateOption.degreeType
      const programMethod = selectedCertificateOption.programMethod
      const location = selectedCertificateOption.location
      const estimatedHours = selectedCertificateOption.estimatedHours
      const description = selectedCertificateOption.description
      const gradeLevel = selectedCertificateOption.gradeLevel
      const knowledgeLevel = selectedCertificateOption.knowledgeLevel
      const functions = selectedCertificateOption.functions
      const pathways = selectedCertificateOption.pathways
      const pathway = selectedCertificateOption.pathway
      const industry = selectedCertificateOption.industry
      const programs = selectedCertificateOption.programs
      const price = selectedCertificateOption.price
      const isContinual = selectedCertificateOption.isContinual
      const isCompleted = selectedCertificateOption.isCompleted
      const dateIssued = selectedCertificateOption.dateIssued
      const expirationDate = selectedCertificateOption.expirationDate
      const url = selectedCertificateOption.url

      const createdAt = new Date()
      const updatedAt = new Date()

      this.setState({ certificateId, courseId, name, imageURL, category, programURL, schoolURL, schoolName, issuerWebsite,
        issuerName, degreeType, programMethod, location, estimatedHours, description, gradeLevel, knowledgeLevel,
        functions, pathways, pathway, industry, programs, price, isContinual, isCompleted, dateIssued, expirationDate, url,
        createdAt, updatedAt
      })
    }

    toggleConfirmDelete() {
      console.log('toggleConfirmDelete called')

      this.setState({ confirmDelete: !this.state.confirmDelete })
    }

    renderConfirmDeleteWidget(type) {
      console.log('renderConfirmDeleteWidget called', type)

      return (
        <div key="renderConfirmDeleteWidget">
          <div>
            <p className={"row-10 description-text-2"}>Are you sure you want to delete this?</p>
            <button type="button" className={"btn btn-squarish error-background-color error-border right-margin-20"} onClick={() => this.deleteItem(type)}>Yes, Delete</button>
            <button type="button" className={"btn btn-squarish white-background cta-color"} onClick={() => this.toggleConfirmDelete()}>Cancel</button>
          </div>
          <div className="clear" />
        </div>
      )
    }

    deleteItem(type) {
      console.log('deleteItem called', type)

      if (type === 'certificate') {

        const profileEmail = this.state.profileEmail
        const certificateId = this.state.certificateId

        Axios.delete('/api/certificates/' + profileEmail + "/" + certificateId)
        .then((response) => {
          console.log('tried to delete', response.data)
          if (response.data.success) {
            console.log('Message delete worked');

            if (this.props.passData) {
              this.props.passData('certificate',{certificateId},true)
            }

            if (this.props.closeModal) {
              this.props.closeModal()
            }

          } else {
            console.error('there was an error deleting the posting');
            this.setState({ errorMessage: response.data.message })
          }
        }).catch((error) => {
            console.log('The deleting did not work', error);
            this.setState({ errorMessage: error.toString() })
        });
      }
    }

    renderTags(type, passedArray) {
      console.log('renderTags called: ', type, passedArray)

      if (type === 'resume') {
        if (this.state.publicResumeName) {
          passedArray = [this.state.publicResumeName]
        } else {
          passedArray = []
        }
      }

      return (
        <div key={type + "|0"}>
          <div className="spacer" />
          {passedArray.map((value, optionIndex) =>
            <div key={type + "|" + optionIndex} className="float-left">
              <div className="close-button-container-1" >
                <button className="background-button" type="button" onClick={() => this.removeTag(type, optionIndex)}>
                  <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                </button>
              </div>
              <div className="float-left right-padding-5">
                <div className="half-spacer" />
                <div className="tag-container-inactive">
                  <p className="description-text-2">{value}</p>
                </div>
                <div className="half-spacer" />
              </div>
            </div>
          )}
        </div>
      )
    }

    removeTag(type, index) {
      console.log('removeTag called', type, index)

      if (type === 'function') {
        let functions = this.state.functions
        functions.splice(index, 1)
        this.setState({ functions, textFormHasChanged: true })
      } else if (type === 'program') {
        let programs = this.state.programs
        programs.splice(index, 1)
        this.setState({ programs, textFormHasChanged: true })
      }
    }

    addItem(type) {
      console.log('addItem called', type)

      if (type === 'function') {

        let functions = this.state.functions
        let addItem = true
        if (functions) {
          if (functions.includes(this.state.workFunction)) {
            addItem = false
          } else {
            functions.unshift(this.state.workFunction)
          }
        } else {
          functions = [this.state.workFunction]
          // console.log('a1', functions)
        }

        if (addItem) {
          this.setState({ functions, workFunction: null })
        }

      } else if (type === 'program') {

        let programs = this.state.programs
        let addItem = true
        if (programs) {
          if (programs.includes(this.state.program)) {
            addItem = false
          } else {
            programs.unshift(this.state.program)
          }
        } else {
          programs = [this.state.program]
        }

        if (addItem) {
          this.setState({ programs, program: null })
        }

      } else {
        console.log('there was an error')
      }
    }

    switchPreferences(change, type) {
      console.log('switchPreferences called', change, type)

      if (type === 'certificate') {
        this.setState({ isContinual: change })
      } else if (type === 'complete') {
        this.setState({ isCompleted: change })
      } else {

      }
    }

    generateCertificateId(name) {
      return `${name}-${new Date().toISOString()}`;
    };

    saveChanges() {
      console.log('saveChanges called')

      this.setState({ isSaving: true, errorMessage: null, successMessage: null })

      if (!this.state.name || this.state.name === '') {
        this.setState({ errorMessage: 'please add a name', isSaving: false })
      } else if (!this.state.degreeType || this.state.degreeType === '') {
        this.setState({ errorMessage: 'please add a type', isSaving: false })
      } else if (!this.state.schoolName || this.state.schoolName === '') {
        this.setState({ errorMessage: 'please add an issuer name', isSaving: false })
      } else if (!this.state.schoolURL || this.state.schoolURL === '') {
        this.setState({ errorMessage: 'please add an issuer website', isSaving: false })
      } else if (!this.state.estimatedHours || this.state.estimatedHours === '') {
        this.setState({ errorMessage: 'please add estimated hours', isSaving: false })
      } else if (!this.state.description || this.state.description === '') {
        this.setState({ errorMessage: 'please add a description', isSaving: false })
      } else {

        const email = this.state.profileEmail
        const delegateAdminEmail = this.state.delegateAdminEmail

        const name = this.state.name
        const imageURL = this.state.imageURL
        const category = this.state.category
        const programURL = this.state.programURL
        const schoolURL = this.state.schoolURL
        const schoolName = this.state.schoolName
        const issuerWebsite = this.state.issuerWebsite
        const issuerName = this.state.issuerName
        const degreeType = this.state.degreeType
        const programMethod = this.state.programMethod
        const location = this.state.location
        const estimatedHours = this.state.estimatedHours
        const description = this.state.description
        const gradeLevel = this.state.gradeLevel
        const knowledgeLevel = this.state.knowledgeLevel
        const functions = this.state.functions
        const pathways = this.state.pathways
        const pathway = this.state.pathway
        const industry = this.state.industry
        const programs = this.state.programs

        const isContinual = this.state.isContinual
        const isCompleted = this.state.isCompleted
        const price = this.state.price

        const dateIssued = this.state.dateIssued
        const expirationDate = this.state.expirationDate
        const url = this.state.url

        const createdAt = new Date()
        const updatedAt = new Date()

        let certificateId = this.state.certificateId
        if (!certificateId) {
          certificateId = this.generateCertificateId(name)
        }

        console.log('show certificateId', certificateId)

        const certificateObject = {
          email, delegateAdminEmail, certificateId, name, imageURL, category, programURL, schoolURL, schoolName, issuerWebsite, issuerName, degreeType,
          programMethod, location, estimatedHours, description, gradeLevel, knowledgeLevel, functions, pathways, pathway, industry, programs,
          isContinual, isCompleted, dateIssued, expirationDate, url,
          price, createdAt, updatedAt
        }

        console.log('show certificateObject: ', certificateObject)

        Axios.post('/api/certificate', certificateObject)
        .then((response) => {

          if (response.data.success) {
            //save values
            console.log('Certificate save worked', response.data);

            this.setState({ successMessage: response.data.message, isSaving: false })

            if (this.props.passData) {
              this.props.passData('certificate',certificateObject)
            }

            if (this.props.closeModal) {
              this.props.closeModal()
            }

          } else {
            console.error('there was an error saving the certificate');
            this.setState({ errorMessage: response.data.message, isSaving: false})
          }
        }).catch((error) => {
            console.log('The certificate save did not work', error);
            this.setState({ errorMessage: error, isSaving: false })
        });
      }

    }

    render() {

      return (
          <div>
            <div className="spacer" />
            <div className="row-10">
              <div>
                <div className="calc-column-offset-20">
                  <p className="heading-text-6">{(this.state._id) ? "Edit" : "Add"} Certificate</p>
                </div>
                <div className="fixed-column-20">
                  <button type="button" className="background-button full-width right-text" onClick={() => this.props.closeModal()}>
                    <img src={closeIcon} alt="GC" className="image-auto-15 pin-right" data-tooltip-id="tooltip-placeholder-id" data-tooltip-content="Close modal"/>
                  </button>
                </div>
                <div className="clear" />
              </div>
              
            </div>

            {(this.state.certificateOptions && this.state.certificateOptions.length > 1) && (
              <div className="row-10">
                <div className="container-left">
                  <p className="profile-label">Select an option from {this.state.orgName}'s list <label className="error-color">*</label></p>
                  <select name={"addCertificateMethod"} value={this.state.addCertificateMethod} onChange={this.formChangeHandler} className="dropdown">
                    {this.state.addCertificateMethodOptions.map(value =>
                      <option key={value} value={value}>{value}</option>
                    )}
                  </select>
                </div>
                {(this.state.addCertificateMethod === 'Yes, select from options') && (
                  <div className="container-right">
                    <p className="profile-label">Select a certificate / badge <label className="error-color">*</label></p>
                    <select name={"certificateOption"} value={this.state.certificateOption} onChange={this.formChangeHandler} className="dropdown">
                      {this.state.certificateOptions.map(value =>
                        <option key={value.name} value={value.name}>{value.name}</option>
                      )}
                    </select>
                  </div>
                )}
                <div className="clear" />
              </div>
            )}

            <div className="row-10">
              <div className="container-left">
                <p className="profile-label">Name <label className="error-color">*</label></p>
                <input type="text" className="text-field" placeholder="(e.g., Adobe Photoshop)..." name={"name"} value={this.state.name} onChange={this.formChangeHandler}></input>
              </div>

              <div className="container-right">
                <p className="profile-label">Type <label className="error-color">*</label></p>
                <select name={"degreeType"} value={this.state.degreeType} onChange={this.formChangeHandler} className="dropdown">
                  {this.state.certificateDegreeTypeOptions.map(value =>
                    <option key={value} value={value}>{value}</option>
                  )}
                </select>
              </div>
              <div className="clear" />
            </div>

            <div className="row-10">
              <div className="container-left">
                <p className="profile-label">Issuer Name<label className="error-color">*</label></p>
                <input type="text" className="text-field" placeholder="(e.g., Harvard University)..." name={"schoolName"} value={this.state.schoolName} onChange={this.formChangeHandler}></input>
              </div>

              <div className="container-right">
                <p className="profile-label">Issuer Website<label className="error-color">*</label></p>
                <input type="text" className="text-field" placeholder="(e.g., https://www.harvard.edu)..." name={"schoolURL"} value={this.state.schoolURL} onChange={this.formChangeHandler}></input>
                {(this.state.schoolURL && this.state.schoolURL !== '' && !this.state.schoolURL.startsWith('http')) && (
                  <div>
                    <p className="error-message">Please start your link with http</p>
                  </div>
                )}
              </div>
              <div className="clear" />
            </div>

            <div className="row-10">
              <div className="container-left">
                <div>
                  <div className="calc-column-offset-30">
                    <p className="profile-label">Avg Estimated Hours to Achieve <label className="error-color">*</label></p>
                  </div>
                  <div className="fixed-column-30">
                    <div className="noti-bubble-info-7-9">
                      <a className="background-link" onClick={() => this.setState({ modalIsOpen: true, showEstimatedHoursDefinition: true })}>
                        <img src={questionMarkBlue} alt="GC" className="image-auto-14 center-item" />
                      </a>
                    </div>
                  </div>
                  <div className="clear" />
                </div>

                <select name={"estimatedHours"} value={this.state.estimatedHours} onChange={this.formChangeHandler} className="dropdown">
                  {this.state.estimatedHoursOptions.map(value =>
                    <option key={value} value={value}>{value}</option>
                  )}
                </select>
              </div>
              <div className="container-right">
                <p className="profile-label">Link to {(this.state.degreeType) ? this.state.degreeType : "Certificate"} (Optional)</p>
                <input type="text" className="text-field" placeholder="(e.g., https://www.certificate.com/123)..." name={"url"} value={this.state.url} onChange={this.formChangeHandler}></input>
              </div>
              <div className="clear" />
            </div>

            <div className="row-10">
              <div className="container-left">
                <p className="profile-label">Work Functions</p>
                <div className="calc-column-offset-70">
                  <select name={"workFunction"} value={this.state.workFunction} onChange={this.formChangeHandler} className="dropdown">
                    {this.state.functionOptions.map(value =>
                      <option key={value.value} value={value.value}>{value.value}</option>
                    )}
                  </select>
                </div>
                <div className="fixed-column-70 left-padding">
                  <button className="btn btn-squarish pin-right" type="button" onClick={() => this.addItem('function')}>Add</button>
                </div>
                <div className="clear" />

                {(this.state.functions) && (
                  <div>
                    {this.renderTags('function', this.state.functions)}
                  </div>
                )}

              </div>
              {(this.state.programOptions && this.state.programOptions.length > 0) && (
                <div className="container-right">
                  <p className="profile-label">Programs</p>
                  <div className="calc-column-offset-70">
                    <select name={"program"} value={this.state.program} onChange={this.formChangeHandler} className="dropdown">
                      {this.state.programOptions.map(value =>
                        <option key={value.title} value={value.title}>{value.title}</option>
                      )}
                    </select>
                  </div>
                  <div className="fixed-column-70 left-padding">
                    <button className="btn btn-squarish pin-right" type="button" onClick={() => this.addItem('program')}>Add</button>
                  </div>
                  <div className="clear" />

                  {(this.state.programs) && (
                    <div>
                      {this.renderTags('program', this.state.programs)}
                    </div>
                  )}

                </div>
              )}

              <div className="clear" />
            </div>

            <div className="row-10">
              <div className="container-left">
                <p className="profile-label">Industry</p>
                <select name={"industry"} value={this.state.industry} onChange={this.formChangeHandler} className="dropdown">
                  {this.state.industryOptions.map(value =>
                    <option key={value.value} value={value.value}>{value.value}</option>
                  )}
                </select>
              </div>
              {(this.state.newPathwayOptions && this.state.newPathwayOptions.length > 0) && (
                <div className="container-right">
                  <p className="profile-label">Pathway</p>
                  <select name={"pathway"} value={this.state.pathway} onChange={this.formChangeHandler} className="dropdown">
                    {this.state.newPathwayOptions.map(value =>
                      <option key={value.title} value={value.title}>{value.title}</option>
                    )}
                  </select>
                </div>
              )}
              <div className="clear" />
            </div>

            <div className="row-10">
              <div className="container-left">
                <p className="profile-label">Are you still working on this {(this.state.degreeType) ? this.state.degreeType : "Certificate"}?</p>
                <Switch
                  onChange={(change) => this.switchPreferences(change,'certificate')}
                  checked={this.state.isContinual}
                  id="normal-switch"
                  disabled={this.state.isSaving}
                />
              </div>
              <div className="container-right">
                <p className="profile-label">Did you complete this {(this.state.degreeType) ? this.state.degreeType : "Certificate"}?</p>
                <Switch
                  onChange={(change) => this.switchPreferences(change,'complete')}
                  checked={this.state.isCompleted}
                  id="normal-switch"
                  disabled={this.state.isSaving}
                />
              </div>
              <div className="clear" />
            </div>

            <div className="row-10">
              <div className="container-left">
                <p className="profile-label">Date Received</p>
                <input type="date" className="date-picker white-background" name={"dateIssued"} value={convertDateToString(new Date(this.state.dateIssued),'rawDateForInput')} onChange={this.formChangeHandler}></input>
              </div>
              <div className="container-right">
                <p className="profile-label">Expiration Date (Optional)</p>
                <input type="date" className="date-picker white-background" name={"expirationDate"} value={convertDateToString(new Date(this.state.expirationDate),'rawDateForInput')} onChange={this.formChangeHandler}></input>
              </div>
              <div className="container-right">

              </div>
              <div className="clear" />
            </div>

            <div className="row-10">
              <p className="profile-label">Description <label className="error-color">*</label></p>
              <textarea type="text" className="text-field" placeholder="Add a description of the certificate, badge, or certification..." name={"description"} value={this.state.description} onChange={this.formChangeHandler}></textarea>
            </div>

            {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="error-color description-text-2 row-5">{this.state.errorMessage}</p>}
            {(this.state.successMessage && this.state.successMessage !== '') && <p className="cta-color description-text-2 row-5">{this.state.successMessage}</p>}

            {(this.state.confirmDelete) && (
              <div className="row-20">
                {this.renderConfirmDeleteWidget('certificate')}
              </div>
            )}

            <button className="btn btn-primary right-margin" disabled={this.state.isSaving} onClick={() => this.saveChanges()}>Save Changes</button>
            {(this.state.certificateId) && (
              <button className="btn btn-quaternary" disabled={this.state.isSaving} onClick={() => this.toggleConfirmDelete()}>Delete Certificate</button>
            )}
          </div>

      )
    }
}

export default withRouter(EditCertificate);
